import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { components as c } from "@/components";
import { usePatientsCopy } from "@/features/i18n/patientsCopy";
import { DiaryAddKindCards, type DiaryAddKind } from "@/features/patients/update/DiaryAddKindCards";

const UpdateDiaryAddPage = () => {
    const copy = usePatientsCopy();
    const { diaryId } = Route.useParams();
    const navigate = useNavigate();

    const handleSelect = (kind: DiaryAddKind) => {
        if (kind === "consent") {
            void navigate({ to: "/patients/$diaryId/update/consent", params: { diaryId } });
            return;
        }
        if (kind === "template") {
            void navigate({ to: "/patients/$diaryId/update/templates", params: { diaryId } });
            return;
        }
        void navigate({
            to: "/patients/$diaryId/update/existing-trackers",
            params: { diaryId },
            search: { type: kind === "event" ? "intervention" : "questionnaire" },
        });
    };

    return (
        <div className="space-y-8 min-w-0 max-w-3xl">
            <c.cc.Title words={copy.addToDiaryTitle} description={copy.addToDiaryDescription} />
            <DiaryAddKindCards onSelect={handleSelect} />
        </div>
    );
};

export const Route = createFileRoute("/_app/patients/$diaryId/update/add")({
    component: UpdateDiaryAddPage,
});
